import fc from "@/components/shared/file_categories"

const foParams = [
  {
    product: "DESIGN",
    title: "Design Only Order",
    description: "Design Only",
    image: require("@/assets/design-only-prosthesis.png"),
    caseType: "direct",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: true,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: true,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: true,
      photogrammetryHealingCaps: true,
      photogrammetryLibraryExport: true
    },
    fileCategories: {
      mandatory: [
        fc.photogrammetryImplantPositionExport,
        fc.photogrammetryImplantPositionExport,
        fc.existingProsthesisInSituScan,
        fc.tissueOfRestoringArchUsingNarrowScanBodies,
        fc.existingProsthesisExtraOrally360UsingScanAnalogs,
        fc.antagonistDentition,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ],
      optional: [fc.biteScan]
    }
  },
  {
    product: "BAR",
    title: "Bar Only Order",
    description: "Bar Only",
    image: require("@/assets/milled-bar-only.png"),
    caseType: "direct",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: true,
      photogrammetryHealingCaps: true,
      photogrammetryLibraryExport: true
    },
    fileCategories: {
      mandatory: [
        fc.photogrammetryImplantPositionExport,
        fc.toothDesign,
        fc.constructionInfo
      ],
      optional: [fc.tissueOfRestoringArchUsingNarrowScanBodies]
    }
  },
  {
    product: "FINISHED-CASE",
    title: "Finished Prosthesis Order",
    description: "Finished Case",
    image: require("@/assets/final-prosthesis-bar-retained.png"),
    caseType: "handover",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: true,
      photogrammetryHealingCaps: true,
      photogrammetryLibraryExport: true
    },
    fileCategories: {
      mandatory: [
        fc.photogrammetryImplantPositionExport,
        fc.existingProsthesisInSituScan,
        fc.tissueOfRestoringArchUsingNarrowScanBodies,
        fc.existingProsthesisExtraOrally360UsingScanAnalogs,
        fc.antagonistDentition,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ],
      optional: [fc.biteScan]
    }
  },
  {
    product: "VIRTUAL-SMILE-DESIGN",
    title: "Virtual Smile Design",
    description: "Virtual Smile Design",
    image: require("@/assets/virtual-smile-design.png"),
    caseType: "handover",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: false,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: false,
      photogrammetryHealingCaps: false
    },
    fileCategories: {
      mandatory: [
        fc.upperDentition,
        fc.lowerDentition,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ],
      optional: [fc.biteScan]
    }
  },
  {
    product: "IMMEDIATE-DESIGN",
    title: "Immediate Design",
    description: "Immediate Design",
    image: require("@/assets/immediate-design-only.png"),
    caseType: "handover",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: false,
      photogrammetryHealingCaps: false
    },
    fileCategories: {
      mandatory: [],
      optional: [
        fc.tissueOfRestoringArch,
        fc.tissueOfRestoringArchUsingNarrowScanBodies,
        fc.midGaugeScan,
        fc.sstDenture360,
        fc.biteScan,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ]
    }
  },
  {
    product: "IMMEDIATE-BRIDGE",
    title: "Immediate Bridge on Ti Base",
    description: "Immediate Bridge on Ti Base",
    image: require("@/assets/immediate-bridge-on-tibase.png"),
    caseType: "handover",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: false,
      photogrammetryHealingCaps: false
    },
    fileCategories: {
      mandatory: [],
      optional: [
        fc.tissueOfRestoringArch,
        fc.tissueOfRestoringArchUsingNarrowScanBodies,
        fc.midGaugeScan,
        fc.sstDenture360,
        fc.biteScan,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ]
    }
  },
  {
    product: "IMMEDIATE-NEXUS-360",
    title: "Immediate Nexus 360°",
    description: "Immediate Nexus 360°",
    image: require("@/assets/immediate-nexus-360.png"),
    caseType: "handover",
    widgets: {
      foSessionOption: true,
      connectionTypeSelector: false,
      multiUnitConfirmation: true,
      specialRequests: true,
      uploadProjectFiles: true,
      clientOrderForm: false,
      barAfterDesign: false
    },
    photogrammetryWidgets: {
      photogrammetrySystem: false,
      photogrammetryHealingCaps: false
    },
    fileCategories: {
      mandatory: [],
      optional: [
        fc.tissueOfRestoringArch,
        fc.tissueOfRestoringArchUsingNarrowScanBodies,
        fc.midGaugeScan,
        fc.sstDenture360,
        fc.biteScan,
        fc.fullFaceSmilingWithRelaxedBite,
        fc.fullFaceSmilingWithRelaxedBiteUsingRetractors
      ]
    }
  }
]

function flattenFileCategories(order) {
  const flat = {}

  const addFiles = (categories, optional) => {
    for (const key in fc) {
      const category = fc[key]
      if (categories.includes(category)) {
        flat[key] = { ...category, optional: optional }
      }
    }
  }

  addFiles(order.fileCategories.mandatory || [], false)
  addFiles(order.fileCategories.optional || [], true)

  return {
    ...order,
    fileCategories: flat
  }
}

export default foParams.map(flattenFileCategories)
